import React from 'react';

import { PaymentMethod } from '@order/features-ordering';
import { getStripeKeyPrefix } from '@order/integrations-stripe';

import {
  useGiftCardCheckoutFormState,
  type GiftCardCheckoutFormFieldRules,
  type GiftCardCheckoutFormReturn,
} from '../../form';
import { GiftCardCheckoutFormContent } from './components';
import { GiftCardCheckoutPaymentProvider } from './sections';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardCheckoutFormV2 = (props: GiftCardCheckoutFormProps) => {
  const {
    form,
    submitForm,
    paymentMethods,
    purchaseAttempt,
    sectionTitles,
    rules,
    incrementPurchaseAttempt,
  } = props;

  // ─── Form State ────────────────────────────────────────────────────────────

  const { amount, isSubmitting, canSubmit, requestFormSubmission } = useGiftCardCheckoutFormState({
    form,
    submitForm,
  });

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GiftCardCheckoutPaymentProvider form={form}>
      <GiftCardCheckoutFormContent
        key={getStripeKeyPrefix(purchaseAttempt)}
        amount={amount}
        sectionTitles={sectionTitles}
        paymentMethods={paymentMethods}
        form={form}
        rules={rules}
        canSubmit={canSubmit}
        isSubmitting={isSubmitting}
        failPayment={incrementPurchaseAttempt}
        requestFormSubmission={requestFormSubmission}
      />
    </GiftCardCheckoutPaymentProvider>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardCheckoutFormProps = {
  purchaseAttempt: number;
  incrementPurchaseAttempt: () => void;
  form: GiftCardCheckoutFormReturn;
  rules: GiftCardCheckoutFormFieldRules;
  paymentMethods: readonly PaymentMethod[];
  submitForm: () => Promise<void>;
  sectionTitles?: {
    amount: string;
    details: string;
    deliveryDate: string;
    deliveryMethod: string;
    recipientEmail: string;
    paymentMethod: string;
  };
};
